import {Modal as BootstrapModal, ModalFooter, ModalBody, ModalHeader} from 'reactstrap'

import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'
import {getClearanceLabel} from '../../../../shared/services/clearanceConstants.js'

export default class DeleteClearanceModal extends Modal {
  constructor(props) {
    super(props)
    this.state = {loading: false}
  }

  handleDelete = async () => {
    this.setState({loading: true})

    try {
      await this.props.onSubmit(this.props.clearance)
    } finally {
      this.setState({loading: false})
      this.props.closeModal()
    }
  }

  render() {
    const {clearance} = this.props
    if (!clearance) {
      return null
    }

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Suppression</ModalHeader>
        <ModalBody>
          <div className="text-center">
            Vous êtes sur le point de supprimer l&apos;habilitation
            <b>&nbsp;{getClearanceLabel(clearance)}</b>.
            Cette action est irreversible.
          </div>
          <Loader visible={this.state.loading}>
            Suppression...
          </Loader>
        </ModalBody>
        <ModalFooter>
          <button onClick={this.props.closeModal} type="button" className="btn btn-outline-shy">Annuler</button>
          <button onClick={this.handleDelete} type="button" className="ml-auto btn btn-danger">Supprimer</button>
        </ModalFooter>
      </BootstrapModal>
    )
  }
}
